// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    BlogList,
    BlogListFromJSON,
    BlogListToJSON,
    HomeResponse,
    HomeResponseFromJSON,
    HomeResponseToJSON,
    HomeUpdateRequest,
    HomeUpdateRequestFromJSON,
    HomeUpdateRequestToJSON,
  } from '../models';

      export interface GetHomeRequest {
        project?: string;
      }

      export interface UpdateHomeRequest {
        homeUpdateRequest: HomeUpdateRequest;
      }


/**
* no description
*/
export interface FrontendApi {
    /**
      * Get offers and organisations that will be shown on the landing page of respondeco.org
    */
    getHome(requestParameters: GetHomeRequest): Promise<HomeResponse>
    /**
      * Get a list of blog posts that describe the latest updates to the platform
    */
    getUpdates(): Promise<BlogList>
    /**
      * Set the list of offers and organisations
    */
    updateHome(requestParameters: UpdateHomeRequest): Promise<HomeResponse>
}

  /**
  * no description
  */
  export class FrontendApiImpl extends runtime.BaseAPI implements FrontendApi {

    /**
      * Get offers and organisations that will be shown on the landing page of respondeco.org
    */
    async getHomeRaw(requestParameters: GetHomeRequest): Promise<runtime.ApiResponse<HomeResponse>> {
      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.project !== undefined) {
              queryParameters['project'] = requestParameters.project;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/frontend/home`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => HomeResponseFromJSON(jsonValue));
      }

      /**
        * Get offers and organisations that will be shown on the landing page of respondeco.org
      */
      async getHome(requestParameters: GetHomeRequest): Promise<HomeResponse> {
        const response = await this.getHomeRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a list of blog posts that describe the latest updates to the platform
    */
    async getUpdatesRaw(): Promise<runtime.ApiResponse<BlogList>> {
      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/frontend/updates`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => BlogListFromJSON(jsonValue));
      }

      /**
        * Get a list of blog posts that describe the latest updates to the platform
      */
      async getUpdates(): Promise<BlogList> {
        const response = await this.getUpdatesRaw();
        return await response.value();
      }

    /**
      * Set the list of offers and organisations
    */
    async updateHomeRaw(requestParameters: UpdateHomeRequest): Promise<runtime.ApiResponse<HomeResponse>> {
          if (requestParameters.homeUpdateRequest === null || requestParameters.homeUpdateRequest === undefined) {
          throw new runtime.RequiredError('homeUpdateRequest','Required parameter requestParameters.homeUpdateRequest was null or undefined when calling updateHome.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

      const response = await this.request({
      path: `/frontend/home`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
              body: HomeUpdateRequestToJSON(requestParameters.homeUpdateRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => HomeResponseFromJSON(jsonValue));
      }

      /**
        * Set the list of offers and organisations
      */
      async updateHome(requestParameters: UpdateHomeRequest): Promise<HomeResponse> {
        const response = await this.updateHomeRaw(requestParameters);
        return await response.value();
      }

    }
